import { formatPermissionName } from "./permissions";

const MODULE_RULES = [
  ["Chamados", /CHAMADOS/],
  ["Clientes", /EXCLUIR_CLIENTES/],
  ["Cursos", /^ALUNO_EXCLUSIVO$/],
  ["Assinaturas Eletrônicas", /(ASSINATUR|ASSINAR_DOCUMENTOS)/],
  ["Jovem Aprendiz", /(JOVEM[_\s-]*APRENDIZ|YOUNG[_\s-]*APPRENTICE|APRENDIZ)/],
  ["Gestão de Atendidos", /(ATTENDEE|ATENDID)/],
  ["Dados Sensíveis", /ACESSO_CONFIDENCIAL/],
  ["Gestão de Alunos", /(STUDENT|ALUN|TURMAS?_CURSOS_GESTAO_DE_ALUNOS|FREQUENCIA.*ALUN)/],
  ["Banco de Projetos", /(PROJECT_BANK|BANCO_PROJETOS)/],
  ["Recursos Humanos", /(HUMAN_RESOURCES|RECURSOS_HUMANOS|\bRH\b|_RH)/],
  ["Patrimônio", /(ASSET|PATRIMON)/],
  ["Estoque", /(INVENTORY|ESTOQUE)/],
  ["Financeiro", /(FINANCE|FINANCEIRO)/],
  ["CRM", /(^|_)CRM($|_)/],
  ["E-mail", /(MAIL|EMAIL)/],
  ["Agenda", /(CALENDAR|AGENDA|EVENTO)/],
  ["Arquivos", /(FILE|ARQUIV)/],
  ["Cadastros BPM", /(REGISTRATION|CADASTR)/],
  ["Formulários", /(FORM|FORMULAR)/],
  ["Processos", /(PROCESS|PROCESSO)/],
  ["Cursos", /(COURSE|CURSO|TURMA|PROFESSOR|ALUNO|CONTEUDO)/],
  ["Meu Negócio", /(COMPANY|EMPRESA|NEGOCIO|ORGANOGRAMA)/],
  ["Integrações", /(AUTOMATION|AUTOMAC|ASSISTANT|ASSISTENTE|INTEGRATION|INTEGRACAO|INTEGRAÇÃO|\bIA\b)/],
  ["Administração", /(GROUP|GRUPO|PERMISSION|PERMIS|USER|USUARIO|SECTOR|SETOR|AUDIT|AUDITOR)/],
  ["Navegação", /(VIEW_MENU|VISUALIZAR_MENU)/],
];

export const inferPermissionModule = (permissionName) => {
  const normalized = String(permissionName || "").trim().toUpperCase();
  if (!normalized) return "Outros";
  const match = MODULE_RULES.find(([, pattern]) => pattern.test(normalized));
  return match?.[0] || "Outros";
};

const STUDENT_SECTION_ORDER = [
  "Acesso e cadastro",
  "Abas do aluno",
  "Arquivos do aluno",
  "Intercorrências e mediações",
  "Frequência, faltas e atestados",
  "Turmas e cursos",
  "Configurações",
  "Histórico e auditoria",
  "Outras permissões",
];

export const inferPermissionSection = (permissionName, moduleName = inferPermissionModule(permissionName)) => {
  const normalized = String(permissionName || "").trim().toUpperCase();
  if (moduleName !== "Gestão de Alunos") return "Permissões";

  if (/(ARQUIV|FILES?)/.test(normalized)) return "Arquivos do aluno";
  if (/(INTERCORR|INCIDENT|MEDIAC)/.test(normalized)) return "Intercorrências e mediações";
  if (/(FREQUENCIA|ATTENDANCE|ATESTAD|AUSEN|ABSENCE|FALTA)/.test(normalized)) return "Frequência, faltas e atestados";
  if (/(TURMAS?_CURSOS|CLASSES?_COURSES)/.test(normalized)) return "Turmas e cursos";
  if (/CONFIGUR/.test(normalized)) return "Configurações";
  if (/(HISTORICO_ALTERACOES|CHANGE_HISTORY|AUDIT)/.test(normalized)) return "Histórico e auditoria";
  if (/(ABA_|_TAB|ALUNOS_DP|ALUNOS_TOTAL|FULL_DATA|PERSONAL_DATA|ACESSO_CONFIDENCIAL)/.test(normalized)) return "Abas do aluno";
  if (/(MENU_GESTAO_DE_ALUNOS|VISUALIZAR_GESTAO_DE_ALUNOS|GERENCIAR_GESTAO_DE_ALUNOS|GESTAO_DE_ALUNOS)/.test(normalized)) return "Acesso e cadastro";
  return "Outras permissões";
};

export const groupPermissionsByModule = (permissions = [], filter = "") => {
  const term = String(filter || "").trim().toLocaleLowerCase("pt-BR");
  const grouped = new Map();

  (Array.isArray(permissions) ? permissions : []).forEach((permission) => {
    if (!permission) return;
    const label = formatPermissionName(permission.name);
    const module = inferPermissionModule(permission.name);
    const haystack = `${module} ${label} ${permission.name || ""}`.toLocaleLowerCase("pt-BR");
    if (term && !haystack.includes(term)) return;
    if (!grouped.has(module)) grouped.set(module, []);
    grouped.get(module).push(permission);
  });

  return Array.from(grouped.entries())
    .map(([module, items]) => {
      const sortedPermissions = [...items].sort((a, b) =>
        formatPermissionName(a.name).localeCompare(formatPermissionName(b.name), "pt-BR"),
      );
      const sectionsMap = new Map();
      sortedPermissions.forEach((permission) => {
        const section = inferPermissionSection(permission.name, module);
        if (!sectionsMap.has(section)) sectionsMap.set(section, []);
        sectionsMap.get(section).push(permission);
      });
      const sections = Array.from(sectionsMap.entries())
        .map(([section, sectionPermissions]) => ({ section, permissions: sectionPermissions }))
        .sort((a, b) => {
          if (module !== "Gestão de Alunos") return a.section.localeCompare(b.section, "pt-BR");
          const aIndex = STUDENT_SECTION_ORDER.indexOf(a.section);
          const bIndex = STUDENT_SECTION_ORDER.indexOf(b.section);
          return (aIndex === -1 ? 999 : aIndex) - (bIndex === -1 ? 999 : bIndex);
        });
      return { module, permissions: sortedPermissions, sections };
    })
    .sort((a, b) => a.module.localeCompare(b.module, "pt-BR"));
};
